import {
  DEVICES_FETCH_LISTING,
  DEVICES_FETCH_SCALED
} from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  devices: {
    modbus: { dataSource: [], name: null },
    locals: { dataSource: [], name: null },
    iot: { dataSource: [], name: null }
  },
  isFetching: false,
  scaled: { dataSource: [] }
};

const devices = (state = defaultStore, action) => {
  switch (action.type) {
    case DEVICES_FETCH_LISTING:
      return { ...state };

    case DEVICES_FETCH_LISTING + _PENDING:
      return { ...state, isFetching: true };

    case DEVICES_FETCH_LISTING + _REJECTED:
      return { ...state, isFetching: false };

    case DEVICES_FETCH_LISTING + _FULFILLED:
      return { ...state, devices: action.payload.devices, isFetching: false };

    case DEVICES_FETCH_SCALED:
      return { ...state };

    case DEVICES_FETCH_SCALED + _PENDING:
      return { ...state, isFetching: true };

    case DEVICES_FETCH_SCALED + _REJECTED:
      return { ...state, isFetching: false };

    case DEVICES_FETCH_SCALED + _FULFILLED:
      return { ...state, scaled: action.payload.scaled, isFetching: false };

    default:
      return state;
  }
};

module.exports = devices;



// WEBPACK FOOTER //
// ./reducers/deviceReducer.js